import artwork from '@/lib/halloween-assets.json'

const art = (path: string) => `/halloween/${path}.svg`
const colours = ['brand', 'slime', 'ghost', 'pumpkin']
const words = [
  'happy-halloween',
  'happy-halloween-stacked',
  'spoopyween',
  'spooky-season',
  'trick-or-treat',
  'boo',
]
const rockNames = ['frankenstein', 'ghost', 'mummy', 'pumpkin', 'vampire', 'witch'] as const

export const rockCharacters = Object.fromEntries(
  rockNames.map((name) => [
    name,
    [art(`rock-monsters/rock-${name}-calm`), art(`rock-monsters/rock-${name}-laughing`)],
  ])
) as Record<(typeof rockNames)[number], string[]>

export const halloweenPools = {
  ...artwork,
  all: Object.values(artwork)
    .flat()
    .filter((path) => !path.includes('spider-slime')),
  lettering: colours.flatMap((colour) =>
    words.map((word) => `/halloween/lettering/${colour}/${word}.webp`)
  ),
  'greeting-type': colours.map((colour) => `/halloween/lettering/${colour}/happy-halloween.webp`),
  logos: ['slime', 'moonglow', 'brand', 'vampire'].flatMap((colour) =>
    ['hero-linear', 'hero-stacked', 'hero-alt-stack', 'hero-shorthand'].map((format) =>
      art(`logos/${colour}/${format}`)
    )
  ),
  'maker-marks': ['moonglow', 'slime', 'brand', 'vampire'].map((colour) =>
    art(`logos/${colour}/hero-shorthand`)
  ),
  'legal-marks': [
    'slime-and-bits/bone',
    'slime-and-bits/crossed-bones',
    'slime-and-bits/candle-skull',
    'bats-and-beasts/bat-grey-flat',
  ].map(art),
  'handmade-ghosts': ['holly/happy-ghost', 'holly/ooh-ghost'].map(art),
  'button-bits': [
    'slime-and-bits/bone',
    'slime-and-bits/crossed-bones',
    'slime-and-bits/skull-lilac',
    'slime-and-bits/slime-drip',
    'slime-and-bits/slime-puddle',
    'spooky-kit/bat-small',
    'bats-and-beasts/bat-grey-flat',
    'bats-and-beasts/bat-grey-tall',
    'bats-and-beasts/bat-horns-dive',
    'bats-and-beasts/bat-horns-grey',
    'bats-and-beasts/bat-horns-plum',
    'bats-and-beasts/bat-plum',
    'spooky-kit/potion-green',
    'spooky-kit/skull',
    'spooky-kit/witch-hat',
  ].map(art),
  'title-bits': [
    ...artwork['spooky-kit'],
    ...artwork.pumpkins,
    ...artwork['slime-and-bits'].filter((path) => !path.includes('slime-drop-')),
    '/halloween/bats-and-beasts/cat-arched.svg',
  ],
  charms: [
    'slime-and-bits/bone',
    'slime-and-bits/crossed-bones',
    'bats-and-beasts/bat-grey-flat',
    'bats-and-beasts/bat-plum',
  ].map(art),
  excavation: [
    'dig-site/excavator-bucket',
    'grave-tools/pickaxe-slime',
    'grave-tools/shovel-skull-slime',
    'holly/grave-digger',
    'grave-tools/spade-bat',
  ].map(art),
  drainage: ['dig-site/cone-ghost', 'dig-site/rock-slime'].map(art),
  masonry: ['dig-site/rock-stack-skull', 'dig-site/rock-slime', 'dig-site/excavator-bucket'].map(
    art
  ),
  landscaping: ['grave-tools/rake', 'holly/spade-o-lantern', 'grave-tools/spade-bat'].map(art),
  'friendly-hands': [
    'ghost-hands/hand-shaka-left',
    'ghost-hands/hand-shaka-right',
    'ghost-hands/hand-horns-open',
  ].map(art),
  'night-flight': artwork['bats-and-beasts'].filter((path) => path.includes('/bat-')),
  spiders: [art('bats-and-beasts/spider-slime')],
  hanging: ['grave-tools/lantern', 'slime-and-bits/candle-skull'].map(art),
  lanterns: [
    'holly/green-lantern',
    'holly/purp-lantern',
    'holly/spade-o-lantern',
    'spooky-kit/pumpkin-glow',
  ].map(art),
}
